import { useCallback, useRef } from 'react';

export const useFormattedNumberInput = () => {
  const inputRef = useRef(null);
  const cursorPositionRef = useRef(0);

  const formatValue = useCallback((value) => {
    if (!value) return '';
    const plainNumber = value.replace(/,/g, '');
    const parts = plainNumber.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return parts.join('.');
  }, []);

  const unformatValue = useCallback(value => value.replace(/,/g, ''), []);

  const getNumericValue = useCallback((value) => {
    if (!value) return 0;
    return parseFloat(unformatValue(value)) || 0;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  const handleChange = useCallback((value, selectionStart) => {
    // Save cursor position
    cursorPositionRef.current = selectionStart;

    // Count commas before the cursor
    const valueBeforeCursor = value.substring(0, selectionStart);
    const commasBeforeCursor = (valueBeforeCursor.match(/,/g) || []).length;

    // Clean and format the value
    const sanitizedValue = value.replace(/[^0-9.,]/g, '');
    const parts = sanitizedValue.split('.');
    const validValue = parts[0] + (parts.length > 1 ? '.' + parts.slice(1).join('') : '');
    const formattedValue = formatValue(validValue);

    // Calculate new cursor position
    const newValueBeforeCursor = formattedValue.substring(0, cursorPositionRef.current);
    const newCommasBeforeCursor = (newValueBeforeCursor.match(/,/g) || []).length;
    const commaDifference = newCommasBeforeCursor - commasBeforeCursor;

    // Schedule cursor position update
    setTimeout(() => {
      if (inputRef.current) {
        const newPosition = Math.min(
          cursorPositionRef.current + commaDifference,
          formattedValue.length
        );
        inputRef.current.setSelectionRange(newPosition, newPosition);
      }
    }, 0);

    return formattedValue;
  }, [formatValue]);

  return {
    inputRef,
    formatValue,
    unformatValue,
    getNumericValue,
    handleChange,
  };
};
